export default {"src":"/_next/static/media/Oasys.d99046fe.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};